module.exports = __webpack_public_path__ + "static/media/chatbotgif.730d5895.gif";